import React from 'react';

import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { SimpleGNBTableRow } from './SimpleGNBTableRow';
import { ExpandableGBNTableRow } from './ExpandableGBNTableRow';

interface IProps {
  hole: string;
  index: number;
  onClick: (index: number) => () => void;
  collapsedRow?: number;
}

export const GBNTableRow = (props: IProps) => {
  const { hole, index, onClick, collapsedRow } = props;

  const { gbnResults } = useAssignResultsState();

  const holeResults = gbnResults[Number(hole)];

  return holeResults.length === 1 ? (
    <SimpleGNBTableRow hole={hole} index={index} onClick={onClick} />
  ) : (
    <ExpandableGBNTableRow
      hole={hole}
      index={index}
      onClick={onClick}
      collapsedRow={collapsedRow}
    />
  );
};
